module.exports = __webpack_public_path__ + "img/loginBg.b0330e5d.jpg";